module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "note4"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("The writer, now that his work is concluded, is not inclined to dwell on the difficulties under which he laboured in the preparation of the present volume... The facts and anecdotes brought together in the following pages were found to be very widely scattered, and frequently accompanied by details which on no possible pretense could now be openly published.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("No apology is offered for what is recorded in this book: it was neither compiled for the prurient nor the prudish, the writer’s sole aim being to give (to the best of his ability) a true history.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("—Reverend William M. Cooper,")]), _c('br'), _vm._v("Flagellation and the Flagellants"), _c('em', [_vm._v(", 1870")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_c('em', [_vm._v("If I whet my glittering sword, and mine hand take hold on judgment; I will render vengeance to mine enemies, and will reward them that hate me.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("—Deuteronomy 32:41")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc9537a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/epi.vue
// module id = 72
// module chunks = 0